import React, { Component } from 'react';
import { object } from 'prop-types';
import { withRouter } from 'react-router-dom';
import compose from 'lodash/fp/compose';

import API from '../../../api';
import { promiseLoader } from '../../../components/common/promise-loader';
import ClientDetail from '../../../components/staff/client-detail';

class ClientShow extends Component {
  static propTypes = {
    client: object
  };

  render () {
    const { client } = this.props;
    return <ClientDetail client={client} />;
  }
}

export default compose(
  withRouter,
  promiseLoader(
    ({ match: { params: { id } } }) => API.staff.getClient(id),
    'client',
    true
  )
)(ClientShow);
